import {useState, useEffect, useRef} from 'react';
import WindowButton from '../buttons/WindowButton';
import TextScroller from './TextScroller';
import PlayMiniFillIcon from 'remixicon-react/PlayMiniFillIcon';
import PauseMiniFillIcon from 'remixicon-react/PauseMiniFillIcon';
import SkipForwardMiniFillIcon from 'remixicon-react/SkipForwardMiniFillIcon';
import SkipBackMiniFillIcon from 'remixicon-react/SkipBackMiniFillIcon';
import StopMiniFillIcon from 'remixicon-react/StopMiniFillIcon';
import DraggableComponent from '../DraggableComponent';
import WindowComponent from '../WindowComponent';
import { formatTime } from '../../functions/customFunctions';
import { capitalise } from '../../functions/customFunctions';
import { music } from './music'

import {
  Button,
  WindowContent,
  WindowHeader,
} from 'react95';
import styled from 'styled-components';
import './musicwindow.scss'
const Wrapper = styled.div`
  position: absolute;
  background: transparent;
`;

const MusicWindow = ({ displayTasks, displayingTask, setActiveTask, activeTask, indexingTasks, taskIndices, tasksVisibility, setTasksVisibility ,signingOff, setTaskSwitiching, icons }) => {
  const task = 'music'
  const [isDraggable, setIsDraggable] = useState(true)
  const initialPosition = window.innerWidth <= 600 ? {x: window.innerWidth*0.04, y: 15} : { x: (window.innerWidth - 600)/2, y: 60 }
  const [musicIndex, setMusicIndex] = useState(0)
  const audioRef = useRef(null);
  const autoPlayRef = useRef(false);
  const playbackRequest = useRef(0);
  const [hasOpened, setHasOpened] = useState(false);
  const [countdownTime, setCountdownTime] = useState(music[0].duration);
  const [playing, setPlaying] = useState(false);
  const [buffering, setBuffering] = useState(false);
  const [playbackError, setPlaybackError] = useState('');
  const [isSkipped, setIsSkipped] = useState(false);
  const isOpen = displayTasks.has(task);
  const scrollerRef = useRef();

  useEffect(() => {
    if (isOpen) {
      setHasOpened(true);
      scrollerRef.current?.resume();
    }
  }, [isOpen]);

  const playAudio = () => {
    const audio = audioRef.current;
    if (!audio?.getAttribute('src')) return;
    const request = ++playbackRequest.current;
    setPlaybackError('');
    setBuffering(audio.readyState < 3);
    setPlaying(true);
    audio.play()?.catch((error) => {
      if (request !== playbackRequest.current || error.name === 'AbortError') return;
      setPlaying(false);
      setBuffering(false);
      setPlaybackError('Não foi possível reproduzir. Clique em Reproduzir para tentar novamente.');
    });
  };

  const handlePlay = () => {
    autoPlayRef.current = true;
    playAudio();
  };
  const handlePause = () => {
    autoPlayRef.current = false;
    playbackRequest.current += 1;
    audioRef.current?.pause();
    setPlaying(false);
    setBuffering(false);
  };
  const handleStop = () => {
    handlePause();
    if (audioRef.current) audioRef.current.currentTime = 0;
    setCountdownTime(music[musicIndex].duration);
  };
  const selectTrack = (index) => {
    playbackRequest.current += 1;
    audioRef.current?.pause();
    autoPlayRef.current = true;
    setPlaybackError('');
    setBuffering(true);
    setPlaying(true);
    setIsSkipped(true);
    setCountdownTime(music[index].duration);
    if (index === musicIndex) {
      audioRef.current.currentTime = 0;
      playAudio();
    } else {
      setMusicIndex(index);
    }
  };
  const handleBack = () => selectTrack(audioRef.current?.currentTime > 3
    ? musicIndex : (musicIndex + music.length - 1) % music.length);
  const handleForward = () => selectTrack((musicIndex + 1) % music.length);

  useEffect(() => {
    if (hasOpened && autoPlayRef.current) playAudio();
    // Playback follows track selection, rather than unrelated window renders.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [musicIndex, hasOpened]);

  const updateRemainingTime = () => {
    const audio = audioRef.current;
    if (!audio) return;
    const duration = Number.isFinite(audio.duration) ? audio.duration : music[musicIndex].duration;
    setCountdownTime(Math.max(0, Math.ceil(duration - audio.currentTime)));
  };
  const handleMusicClose = () => {
    scrollerRef.current?.reset();
    scrollerRef.current?.pause();
    handleStop();
  };
  useEffect(() => {
    if (signingOff) handlePause();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signingOff]);
  const iconVisibility = icons[task].visibility;
  useEffect(() => {
    if (iconVisibility === 'hidden') {
      handleMusicClose();
      setMusicIndex(0);
      setCountdownTime(music[0].duration);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [iconVisibility]);

  useEffect(() => {
    const audio = audioRef.current;
    return () => {
      playbackRequest.current += 1;
      audio?.pause();
      audio?.removeAttribute('src');
      audio?.load();
    };
  }, []);

  return (
    <DraggableComponent task={task} initialPosition={initialPosition} setActiveTask={setActiveTask} indexingTasks={indexingTasks} isDraggable={isDraggable} setIsDraggable={setIsDraggable}>
    <Wrapper className="drag-music" style={{zIndex: taskIndices[task], display: displayTasks.has(task) ? 'block' : 'none', visibility: tasksVisibility.music}}>
    <WindowComponent task={task} setActiveTask={setActiveTask} indexingTasks={indexingTasks}>
      <strong className="cursor"><WindowHeader  active={activeTask === task} className='window-title'>
        <span>{capitalise(task)}</span>

        <div className="buttons">
          <WindowButton purpose='minimise' tasksVisibility={tasksVisibility} task={task} setTasksVisibility={setTasksVisibility} setActiveTask={setActiveTask} setTaskSwitiching={setTaskSwitiching} setIsDraggable={setIsDraggable} />
          <WindowButton purpose='close' task={task} displayingTask={displayingTask} setIsDraggable={setIsDraggable} setActiveTask={setActiveTask} handleMusicClose={handleMusicClose} />
        </div>
      </WindowHeader></strong>
      <WindowContent className='window-content'>
        <audio ref={audioRef} src={hasOpened ? music[musicIndex].source : undefined} preload="auto"
          onLoadedMetadata={updateRemainingTime} onTimeUpdate={updateRemainingTime} onEnded={handleForward}
          onWaiting={() => setBuffering(true)} onPlaying={() => { setBuffering(false); setPlaying(true); }}
          onCanPlay={() => setBuffering(false)}
          onError={() => { setPlaying(false); setBuffering(false); setPlaybackError('Não foi possível carregar a música. Tente novamente.'); }} />
        <div className="music-title-container">
          <TextScroller ref={scrollerRef} text={music[musicIndex].title} isSkipped={isSkipped} setIsSkipped={setIsSkipped} displayTasks={displayTasks} />
          <div className='count-down'>{countdownTime ? formatTime(countdownTime) : '--:--'}</div>
        </div>
        <div className="buttons">
          <Button aria-label="Faixa anterior" onClick={handleBack}><SkipBackMiniFillIcon /></Button>
          <Button aria-label="Reproduzir" onClick={handlePlay} disabled={playing}><PlayMiniFillIcon /></Button>
          <Button aria-label="Pausar" onClick={handlePause} disabled={!playing}><PauseMiniFillIcon /></Button>
          <Button aria-label="Parar" onClick={handleStop}><StopMiniFillIcon /></Button>
          <Button aria-label="Próxima faixa" onClick={handleForward}><SkipForwardMiniFillIcon /></Button>
        </div>
        {(buffering || playbackError) && <p className="music-status" role="status">{playbackError || 'Carregando música…'}</p>}
      </WindowContent>
    </WindowComponent>
  </Wrapper>

  </DraggableComponent>

  )
}

export default MusicWindow
